<template>
  <div class="main block3">
    <div class="main_bg">
      <div class="banner">
        <img :src="imageurl" style="width: 100%" />
        <div style="margin-top: -58px;">
          <contentMenu :index="1"></contentMenu>
        </div>
      </div>
      <div class="main-content">
        <div class="image-content">
          <el-carousel
            indicator-position="none"
            :autoplay="false"
            arrow="always"
            style="width: 100%;"
            :height="autoHeight"
          >
            <el-carousel-item>
              <img :src="lbList[0].imageurl" class="image-item-1" @click="showPop(lbList[0])" />
              <img :src="lbList[1].imageurl" class="image-item-2" @click="showPop(lbList[1])" />
              <img :src="lbList[2].imageurl" class="image-item-3" @click="showPop(lbList[2])" />
              <img :src="lbList[3].imageurl" class="image-item-4" @click="showPop(lbList[3])" />
            </el-carousel-item>
            <el-carousel-item>
              <img :src="lbList[4].imageurl" class="image-item-1" @click="showPop(lbList[4])" />
              <img :src="lbList[5].imageurl" class="image-item-2" @click="showPop(lbList[5])" />
              <img :src="lbList[6].imageurl" class="image-item-3" @click="showPop(lbList[6])" />
              <img :src="lbList[7].imageurl" class="image-item-4" @click="showPop(lbList[7])" />
            </el-carousel-item>
            <el-carousel-item>
              <img :src="lbList[8].imageurl" class="image-item-1" @click="showPop(lbList[8])" />
              <img :src="lbList[9].imageurl" class="image-item-2" @click="showPop(lbList[9])" />
              <img :src="lbList[10].imageurl" class="image-item-3" @click="showPop(lbList[10])" />
              <img :src="lbList[11].imageurl" class="image-item-4" @click="showPop(lbList[11])" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="main2-content">
        <contentLeftRoll :list="list[0]"></contentLeftRoll>
        <contentRightRoll :list="list[1]"></contentRightRoll>
        <contentLeftRoll :list="list[2]"></contentLeftRoll>
        <contentRight :list="list[3]" :isIconShow="false" isSubShow isSubEnShow></contentRight>
      </div>
      <div class="main-content">
        <div class="title-content">
          <div class="line"></div>
          <div class="title">最新资讯</div>
        </div>
        <contentLeft :list="list2[0]" isBtnShow></contentLeft>
        <div style="height: 100px;background: #ffffff;"></div>
      </div>
    </div>

    <div class="cover" v-if="showCover"></div>
    <div class="popup" v-if="showCover">
      <div>
        <div class="close" @click="closePop()">
          <img alt="xxx" src="../../assets/meb/imgs/closeIcon@2x.png" style="width: 100%;" />
        </div>
        <div class="img">
          <img :src="showImg" style="width: 100%;" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { csvw_url } from "../../components/config";
import config from "./config";
import contentMenu from "./contentMenu.vue";
import contentLeftRoll from "./contentLeftRoll.vue";
import contentRightRoll from "./contentRightRoll.vue";
import contentLeft from "./contentLeft.vue";
import contentRight from "./contentRight.vue";
export default {
  components: {
    contentMenu,
    contentLeftRoll,
    contentRightRoll,
    contentLeft,
    contentRight
  },
  data() {
    return {
      ...config.scene,
      showCover: false,
      showImg: "",
      autoHeight: "500px"
    };
  },
  beforeMount() {
    let _w = document.documentElement.clientWidth || document.body.clientWidth;
    if (_w >= 1600) {
      this.autoHeight = 660 + "px";
    } else {
      this.autoHeight = 500 + "px";
    }
  },
  mounted() {
    document.body.clientWidth;
    console.log(this);
  },
  methods: {
    showPop(item) {
      this.showCover = true;
      this.showImg = item.imageurlbig;
    },
    closePop() {
      this.showCover = false;
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  min-width: 1200px;
  margin: 0px auto;
  font-size: 14px;
}

.main_bg {
  width: 100%;
  min-width: 1200px;
  background: #ffffff;
}

.main-content {
  width: calc(100% - 0px);
  margin: 0px 0px;

  .image-content {
    width: 1200px;
    padding: 49px 60px 49px 68px;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
  }

  .image-item-1 {
    cursor: pointer;
    width: 725px;
    height: 240px;
  }
  .image-item-2 {
    cursor: pointer;
    width: 335px;
    height: 240px;
    margin-left: 10px;
  }
  .image-item-3 {
    cursor: pointer;
    width: 335px;
    height: 240px;
    margin-top: 10px;
  }
  .image-item-4 {
    cursor: pointer;
    width: 725px;
    height: 240px;
    margin-left: 10px;
    margin-top: 10px;
  }

  .title-content {
    width: 1200px;
    padding: 49px 60px 49px 68px;
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    position: relative;
  }

  .title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 38px;
    font-weight: 400;
    color: #0077c8;
    background: #ffffff;
    padding: 0px 50px;
  }
  .line {
    width: 1080px;
    height: 2px;
    background: #cccccc;
  }
}

.block3 .cover {
  position: fixed;
  /*首先将位置固定住*/
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /*上下左右设置都为0*/
  background: rgba(2, 2, 2, 0.5);
  z-index: 8;
}
.block3 .popup {
  position: fixed;
  margin: auto;
  left: 0;
  right: 0;
  top: 50px;
  bottom: 0;
  width: 960px;
  z-index: 9;
}
.block3 .popup .close {
  position: relative;
  float: right;
  width: 20px;
  cursor: pointer;
}

.main2-content {
  width: calc(100% - 0px);
  margin: 0px 0px;
  background-image: url("../../assets/meb/imgs/xczj/xczjBg@2x.png");
  background-size: 100% 100%;
  background-repeat-x: no-repeat;
}
.divHeight {
  height: 23px;
}

@media screen and (min-width: 1600px) {
  .main-content {
    .image-content {
      width: 1600px;
    }

    .image-item-1 {
      cursor: pointer;
      width: 1010px;
      height: 320px;
    }
    .image-item-2 {
      cursor: pointer;
      width: 440px;
      height: 320px;
      margin-left: 20px;
    }
    .image-item-3 {
      cursor: pointer;
      width: 440px;
      height: 320px;
      margin-top: 20px;
    }
    .image-item-4 {
      cursor: pointer;
      width: 1010px;
      height: 320px;
      margin-left: 20px;
      margin-top: 20px;
    }

    .title-content {
      width: 1600px;
    }
    .line {
      width: 1600px;
      height: 3px;
    }
  }
}
</style>
